import { lazy } from 'react';

const UserView = lazy(() => import('./UserView'));

export default UserView;
